import React, {Component} from 'react';
import AuthService from "../AuthService";
// import Tap from "@tapfiliate/tapfiliate-js";


import '../css/main.css';
import '../css/public.css';
import logo from '../img/logo.png';

// Tap.init('60274-c4be13');

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            login: '',
            password: '',
            errorMessage: null
        };
        this.change = this.change.bind(this);
        this.submit = this.submit.bind(this);
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    submit(e) {
        e.preventDefault();
        AuthService.login({
            login: this.state.login,
            password: this.state.password
        }).then(res => {
            localStorage.setItem('token', JSON.stringify(res.data.token));
            localStorage.setItem('refresh_token', JSON.stringify(res.data.refresh_token));
            this.props.history.push('/admin/reservations');
        }).catch(err => {
            this.setState({errorMessage: 'Authentification impossible'});
        });
    }

    render() {
        return(
            <div className="bodyContent">
                <div id="loginBox">
                    <img alt="Green River Cruises" src={logo} />
                    <form id="loginFormBox" onSubmit={e => this.submit(e)}>
                        <div className="loginFormBox-field">
                            <input type="text" name="login" value={this.state.login} onChange={e => this.change(e)}/>
                        </div>
                        <div className="loginFormBox-field">
                            <input type="password" name="password" value={this.state.password} onChange={e => this.change(e)}/>
                        </div>
                        {this.state.errorMessage &&
                            <ul className="errorMessage alignCenter">
                                <li><span>{this.state.errorMessage}</span></li>
                            </ul>
                        }
                        <div className="loginFormBox-line alignCenter">
                            <button type="submit" className="formSubmit" disabled={!this.state.login || !this.state.password}>CONNEXION</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default Home;

